import React from 'react';
import Button from '../Button/Button';
import { IconBellL } from '../../icons';
import css from './index.css';
import IconSpinner from '../IconSpinner/IconSpinner';
import Popup from './Popup';
import OutsideClickHandler from '../OutsideClickHandler/OutsideClickHandler';
import ModalPortal from '../ModalPortal/ModalPortal';
import Notification from './Notification';
import { useCustomNotificationContext } from './context';

const Content = ({ renderCustomElement }) => {
    const {
        inProgress,
        hasNewNotifications,
        userCustomNotifications,
        notificationsRequestFailed,
        popupOpen,
        modalOpen,
        setOpen,
        open,
        computing,
    } = useCustomNotificationContext();

    const noData = Array.isArray(userCustomNotifications) && userCustomNotifications.length === 0;
    const disabled = noData || computing || notificationsRequestFailed;

    const popup = popupOpen && (
        <>
            <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
                <Popup />
            </OutsideClickHandler>
            <div className={css.overlay} />
        </>
    );

    const modal = modalOpen && (
        <ModalPortal id="notifications/custom" onClose={() => setOpen(false)} isOpen>
            <div>
                {userCustomNotifications.map(notification => (
                    <Notification
                        key={notification._id || notification.id}
                        notification={notification}
                    />
                ))}
            </div>
        </ModalPortal>
    );

    if (typeof renderCustomElement === 'function') {
        return renderCustomElement({ open, inProgress, setOpen, modal, popup, disabled });
    }

    if (inProgress) {
        return <IconSpinner />;
    }

    return (
        <>
            <div className={css.root}>
                {hasNewNotifications && <code className={css.notificationDot} />}
                <Button
                    className={css.actionButton}
                    type="button"
                    disabled={disabled}
                    onClick={() => setOpen(prevState => !prevState)}
                >
                    <code tabIndex="0" role="button" aria-label="Notifications" href="#">
                        <IconBellL />
                    </code>
                </Button>
                {popup}
                {modal}
            </div>
        </>
    );
};

export default Content;
